import React, { useEffect } from 'react';
import { Box, Modal, Grid, Zoom, Container } from '@mui/material';
import { CancelButton, InputFieldBox, ItemLabelBox, ItemLabelTypography, ItemTextField, ModalLabel, modalStyle, OkButton, SpecificationTypography } from './seinengappiCondition.styles';
import { sessionDisconnectedCheck } from '../../../shared/api/sessionDisconnectedCheck';
import { useNavigate } from 'react-router-dom';

interface OwnProps {
    isOpen: boolean,
    handleClose: (isOpen: boolean) => void
    handleOk: (directItem: string, rangeItems: RangeDialogItem) => void,
}

interface RangeDialogItem {
    from: string
    to: string
}

const screenId = "U044"

const SeinengappiDialog = (props: OwnProps) => {
    const navigate = useNavigate();
    const { isOpen, handleClose } = props
    const [open, setOpen] = React.useState(isOpen);

    const initialItemState: { [key: string]: string } = {
        directItem: '',
        rangeFromValue: '',
        rangeToValue: '',
    }

    const initialErrorState: { [key: string]: boolean } = {
        noInputError: false,
        duplicationError: false,
        toSmallError: false,
        directOutOfRangeError: false,
        rangeFromOutOfRangeError: false,
        rangeToOutOfRangeError: false,
    }

    const [itemsState, setItemsState] = React.useState<{ [key: string]: string }>(initialItemState);
    const [errorsState, setErrorsState] = React.useState<{ [key: string]: boolean }>(initialErrorState);

    useEffect(() => {
        if (isOpen) {
            setItemsState(initialItemState);
            setErrorsState(initialErrorState);
        }
        setOpen(isOpen)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen])

    const handleChangeDirect = (inputVal: string) => {
        if (inputVal.length <= 8) {
            setItemsState(preItemsState => { return { ...preItemsState, directItem: inputVal.replaceAll(/[^0-9]/g, "") } });
        }
    };

    const handleChangeRangeFrom = (inputVal: string) => {
        if (inputVal.length <= 8) {
            setItemsState(preItemsState => { return { ...preItemsState, rangeFromValue: inputVal.replaceAll(/[^0-9]/g, "") } });
        }
    };

    const handleChangeRangeTo = (inputVal: string) => {
        if (inputVal.length <= 8) {
            setItemsState(preItemsState => { return { ...preItemsState, rangeToValue: inputVal.replaceAll(/[^0-9]/g, "") } });
        }
    };

    const checkOutOfRange = (inputVal: string) => {
        const min = 18000101;
        const max = 20991231;
        const numValue = Number(inputVal);
        if (numValue >= min && numValue <= max) {
            return false;
        } else {
            return true;
        }
    }

    const handleOk = async () => {
        // セッションの有効性確認
        if (await sessionDisconnectedCheck(screenId, "seinengappiHandleOk", navigate)) {
            return
        }
        setErrorsState(initialErrorState);
        if (itemsState.directItem === '' && itemsState.rangeFromValue === '' && itemsState.rangeToValue === '') {
            setErrorsState(preErrorsState => { return { ...preErrorsState, noInputError: true } });
        } else if (itemsState.directItem !== '' && (itemsState.rangeFromValue !== '' || itemsState.rangeToValue !== '')) {
            setErrorsState(preErrorsState => { return { ...preErrorsState, duplicationError: true } });
        } else if ((itemsState.rangeFromValue !== '' && itemsState.rangeToValue !== '') && (Number(itemsState.rangeFromValue) > Number(itemsState.rangeToValue))) {
            setErrorsState(preErrorsState => { return { ...preErrorsState, toSmallError: true } });
        } else if (itemsState.directItem !== '' && checkOutOfRange(itemsState.directItem)) {
            setErrorsState(preErrorsState => { return { ...preErrorsState, directOutOfRangeError: true } });
        } else if (itemsState.rangeFromValue !== '' && checkOutOfRange(itemsState.rangeFromValue)) {
            setErrorsState(preErrorsState => { return { ...preErrorsState, rangeFromOutOfRangeError: true } });
        } else if (itemsState.rangeToValue !== '' && checkOutOfRange(itemsState.rangeToValue)) {
            setErrorsState(preErrorsState => { return { ...preErrorsState, rangeToOutOfRangeError: true } });
        } else {
            const rangeItems = { from: itemsState.rangeFromValue, to: itemsState.rangeToValue }
            props.handleOk(itemsState.directItem, rangeItems)
        }
    }

    return (
        <>
            <Modal
                open={open}
                onClose={handleClose}
                closeAfterTransition
                sx={{
                    zIndex: 900
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            zIndex: 900
                        }
                    }
                }}
            >
                <Zoom
                    in={open}
                    style={{ zIndex: 1000, transformOrigin: '-50% -50% -50%' }}
                    easing={{
                        enter: "cubic-bezier(0, 1.45, 0.62, 1)",
                        exit: "linear"
                    }}
                >
                    <Box sx={modalStyle} tabIndex={-1}>
                        <ModalLabel>
                            選択条件 - 生年月日
                        </ModalLabel>
                        <Box sx={{ marginTop: '3%', marginBottom: '3%', color: '#6d6d6dff', fontSize: '1.2rem' }}>※YYYYMMDD形式で入力してください（例20250101）</Box>
                        {
                            errorsState.noInputError ?
                                <Box sx={{ marginTop: '2%', marginBottom: '-2%', color: 'red', fontSize: '1.2rem' }}>   直接指定か範囲指定に値を入力してください</Box>
                                :
                                <></>
                        }
                        {
                            errorsState.duplicationError ?
                                <Box sx={{ marginTop: '2%', marginBottom: '-2%', color: 'red', fontSize: '1.2rem' }}>   直接指定か範囲指定のどちらか一方のみ入力してください</Box>
                                :
                                <></>
                        }
                        <InputFieldBox m={2} paddingTop={6} paddingBottom={2}>
                            <SpecificationTypography variant='h6'>直接指定</SpecificationTypography>
                            <Container sx={{ width: '65%' }}>
                                <Grid container columnSpacing={0.5}>
                                    <Grid size={5.5}>
                                        <ItemLabelBox>
                                            <ItemLabelTypography marginLeft='10px'>生年月日</ItemLabelTypography>
                                        </ItemLabelBox>
                                    </Grid>
                                    <Grid size={6.5}>
                                        <ItemTextField placeholder='YYYYMMDD' value={itemsState.directItem} variant='outlined' size='small' error={errorsState.duplicationError || errorsState.directFormatError || errorsState.directOutOfRangeError} onChange={(event) => handleChangeDirect(event.target.value)} />
                                    </Grid>
                                </Grid>
                                {
                                    errorsState.directOutOfRangeError ?
                                        <Box sx={{ marginTop: '2%', marginBottom: '-2%', color: 'red', fontSize: '1.2rem' }}>   18000101～20991231の値を入力してください</Box>
                                        :
                                        <></>
                                }
                            </Container>
                        </InputFieldBox>
                        <InputFieldBox m={2} p={4}>
                            <SpecificationTypography variant='h6'>範囲指定</SpecificationTypography>
                            <Container sx={{ width: '75%' }}>
                                <Box m={2} sx={{ color: '#6d6d6dff', fontSize: '1.2rem' }}>※どちらか一方の入力も可能</Box>
                                <Grid container columnSpacing={0.5}>
                                    <Grid size={5}>
                                        <ItemTextField placeholder='YYYYMMDD' value={itemsState.rangeFromValue} variant='outlined' size='small' error={(errorsState.duplicationError && itemsState.rangeFromValue !== '') || errorsState.toSmallError || errorsState.rangeFromFormatError || errorsState.rangeFromOutOfRangeError} onChange={(event) => handleChangeRangeFrom(event.target.value)} />
                                    </Grid>
                                    <Grid alignContent='center' size={2}>
                                        ～
                                    </Grid>
                                    <Grid size={5}>
                                        <ItemTextField placeholder='YYYYMMDD' value={itemsState.rangeToValue} variant='outlined' size='small' error={(errorsState.duplicationError && itemsState.rangeToValue !== '') || errorsState.toSmallError || errorsState.rangeToFormatError || errorsState.rangeToOutOfRangeError} onChange={(event) => handleChangeRangeTo(event.target.value)} />
                                    </Grid>
                                </Grid>
                                {
                                    errorsState.toSmallError ?
                                        <Box sx={{ marginTop: '2%', marginBottom: '-2%', color: 'red', fontSize: '1.2rem' }}>   範囲指定の終了値が開始値より小さいです</Box>
                                        :
                                        <></>
                                }
                                {
                                    errorsState.rangeFromOutOfRangeError || errorsState.rangeToOutOfRangeError ?
                                        <Box sx={{ marginTop: '2%', marginBottom: '-2%', color: 'red', fontSize: '1.2rem' }}>   18000101～20991231の値を入力してください</Box>
                                        :
                                        <></>
                                }
                            </Container>
                        </InputFieldBox>
                        <Box p={2} sx={{ marginTop: '-3%', marginBottom: '1%' }}>
                            <Grid container sx={{ width: '98%' }}>
                                <Grid size={7} />
                                <Grid size={5}>
                                    <CancelButton variant="contained" onClick={() => handleClose(false)}>キャンセル</CancelButton>
                                    <OkButton variant="contained" onClick={() => handleOk()}>OK</OkButton>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Zoom>
            </Modal >
        </>
    );
}

export default SeinengappiDialog;
